export default {
    // 查询个人信息收集清单
    selectCollectedPersonalInfoList:
        "/gateway/huilianCust/accountcs/selectCollectedPersonalInfoList",
};



// WEBPACK FOOTER //
// ./src/informationCollectionList/index/api.js